import React from "react";
import { Field } from "formik";
import { Box } from "@mui/material";
import AdxFormControlLabel from "components/custom/AdxFormControlLabel";
import AdxCheckbox from "components/custom/AdxCheckbox";

const CreditDocument = ({ formikBag }) => {
  const { values, setFieldValue } = formikBag;
  return (
    <Box display="flex" flexDirection="column">
      <AdxFormControlLabel
        type="no-fill"
        label="Requires Documentation"
        description="Enable this if proper documentation is required for leave credit request"
        control={
          <Field
            as={AdxCheckbox}
            name="attachment_required"
            checked={Boolean(values.attachment_required)}
            onChange={(e) =>
              setFieldValue("attachment_required", e.target.checked ? 1 : 0)
            }
          />
        }
      />
      <AdxFormControlLabel
        type="no-fill"
        label="Requires Reasoning"
        description="Enable if reasoning is required to apply"
        control={
          <Field
            as={AdxCheckbox}
            name="reason_required"
            checked={Boolean(values.reason_required)}
            onChange={(e) =>
              setFieldValue("reason_required", e.target.checked ? 1 : 0)
            }
          />
        }
      />
    </Box>
  );
};

export default CreditDocument;
